import Vue from 'vue'
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
import teacher from '@/pages/teacher'
import jzs1 from '@/pages/jzs1'
import jzs2 from '@/pages/jzs2'
import aq from '@/pages/aq'
import cfe from '@/pages/cfe'
import jianli from '@/pages/jianli'
import zaojia from '@/pages/zaojia'
import zjy from '@/pages/zjy'
import zjxfy from '@/pages/zjxfy'
import yaoshi from '@/pages/yaoshi'
import jiankanggls from '@/pages/jiankanggls'

Vue.use(Router);



export default new Router({
    routes: [
        {
            path: '/teacher',
            name: 'teacher',
            component: teacher,
            meta: {
                title: '教师资格',
                isDomain: true,

            }
        },
        {
            path: '/jzs1',
            name: 'jzs1',
            component: jzs1,
            meta: {
                title: '一级建造师',
                isDomain: true,

            }
        },
        {
            path: '/jzs2',
            name: 'jzs2',
            component: jzs2,
            meta: {
                title: '二级建造师',
                isDomain: true,

            }
        },
        {
            path: '/aq',
            name: 'aq',
            component: aq,
            meta: {
                title: '安全工程师',
                isDomain: true,

            }
        },
        {
            path: '/cfe',
            name: 'cfe',
            component: cfe,
            meta: {
                title: '一级消防工程师',
                isDomain: true,

            }
        },
        {
            path: '/jianli',
            name: 'jianli',
            component: jianli,
            meta: {
                title: '监理工程师',
                isDomain: true,

            }
        },
        {
            path: '/zaojia',
            name: 'zaojia',
            component: zaojia,
            meta: {
                title: '造价工程师',
                isDomain: true,

            }
        },
        {
            path: '/zjy',
            name: 'zjy',
            component: zjy,
            meta: {
                title: '二级造价工程师',
                isDomain: true,

            }
        },
        {
            path: '/zjxfy',
            name: 'zjxfy',
            component: zjxfy,
            meta: {
                title: '消防设施操作员',
                isDomain: true,

            }
        },
        {
            path: '/yaoshi',
            name: 'yaoshi',
            component: yaoshi,
            meta: {
                title: '职业药师',
                isDomain: true,

            }
        },
        {
            path: '/jiankanggls',
            name: 'jiankanggls',
            component: jiankanggls,
            meta: {
                title: '健康管理师',
                isDomain: true,

            }
        },
    ]
})



